import { render, staticRenderFns } from "./inventory-stors.vue?vue&type=template&id=a4107aa0"
import script from "./inventory-stors.vue?vue&type=script&lang=js"
export * from "./inventory-stors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports